import axios from 'axios';

// Use a plain axios instance without the portal-token interceptor,
// so the speaker token is not overridden by the enrollment token in localStorage.
const speakerClient = axios.create({
  baseURL: '/api',
  withCredentials: false,
});

export interface SpeakerProfile {
  id: string;
  nome: string;
  cognome: string;
  bio?: string;
  azienda?: string;
  linkedin_url?: string;
  photo_url?: string;
}

export interface SpeakerEdition {
  id: string;
  label: string;
  scheduled_at: string;
  zoom_meeting_url?: string;
  course_name: string;
  course_slug: string;
}

export interface SpeakerMaterial {
  id: string;
  edition_id: string;
  course_name: string;
  title: string;
  description?: string;
  type: string;
  external_url?: string;
  file_size_bytes?: number;
  available_from: string;
  sort_order: number;
  created_at: string;
}

export interface SpeakerPortalData {
  speaker: SpeakerProfile;
  editions: SpeakerEdition[];
  materials: SpeakerMaterial[];
}

function authHeader(token: string) {
  return { Authorization: `Bearer ${token}` };
}

export async function getSpeakerMe(token: string): Promise<SpeakerPortalData> {
  const res = await speakerClient.get('/speaker/me', { headers: authHeader(token) });
  return res.data;
}

export async function updateSpeakerProfile(token: string, formData: FormData): Promise<SpeakerProfile> {
  const res = await speakerClient.put('/speaker/profile', formData, {
    headers: { ...authHeader(token), 'Content-Type': 'multipart/form-data' },
  });
  return res.data.speaker;
}

export async function uploadSpeakerMaterial(token: string, formData: FormData): Promise<SpeakerMaterial> {
  const res = await speakerClient.post('/speaker/materials', formData, {
    headers: { ...authHeader(token), 'Content-Type': 'multipart/form-data' },
  });
  return res.data.material;
}

export async function deleteSpeakerMaterial(token: string, materialId: string): Promise<void> {
  await speakerClient.delete(`/speaker/materials/${materialId}`, { headers: authHeader(token) });
}

export async function downloadSpeakerMaterial(token: string, materialId: string, filename: string): Promise<void> {
  const res = await speakerClient.get(`/speaker/materials/${materialId}/download`, {
    headers: authHeader(token),
    responseType: 'blob',
  });
  const url = URL.createObjectURL(res.data);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export async function sendSpeakerContactMessage(token: string, subject: string, message: string): Promise<void> {
  await speakerClient.post(`/speaker/${token}/contact`, { subject, message });
}
